/**
 * 全局项目上下文（S04）。
 *
 * 项目切换器是所有资产/实验接口的入口参数：S06 起 callApi 统一从这里带 projectId。
 * S04 骨架阶段项目列表还是本地种子数据（projects 接口在 S06 落地），切完存 localStorage。
 */

import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from "react";

export interface ProjectOption {
  id: string;
  name: string;
}

const STORAGE_KEY = "atc.currentProjectId";

const SEED_PROJECTS: ProjectOption[] = [
  { id: "seed-default", name: "默认项目" },
  { id: "seed-warehouse", name: "仓储搬运（demo）" },
];

interface ProjectContextValue {
  projects: ProjectOption[];
  projectId: string;
  switchProject: (id: string) => void;
}

const ProjectContext = createContext<ProjectContextValue | null>(null);

export function ProjectProvider({ children }: { children: ReactNode }) {
  const [projectId, setProjectId] = useState<string>(
    () => localStorage.getItem(STORAGE_KEY) || SEED_PROJECTS[0]?.id || "seed-default"
  );

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, projectId);
  }, [projectId]);

  const value = useMemo<ProjectContextValue>(
    () => ({
      projects: SEED_PROJECTS,
      projectId,
      switchProject: setProjectId,
    }),
    [projectId]
  );

  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
}

export function useProject(): ProjectContextValue {
  const ctx = useContext(ProjectContext);
  if (!ctx) throw new Error("useProject 必须在 ProjectProvider 内使用");
  return ctx;
}
